import React, { Component } from "react";
import { Rune } from "@outplayed/tooltips";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { useGlobal } from "reactn";
import { useLocation } from "react-router";

const RuneTreeCondensed = (props) => {
  const { perkStyle, activePerks, version, ssr } = props;
  const { getRuneJSON, useRiotRunes } = getRiotAssetsContext();
  const location = useLocation();
  const [language] = useGlobal("language");
  const { data, loading, error } = useRiotRunes({ patch: version, ssr, language });

  const buildPerks = (version) => {
    const path = data?.find((path) => {
      return path.id === Number(perkStyle);
    }).slots;
    let perksToDisplay = [];

    path?.forEach((row, index) => {
      row.runes.forEach((perk) => {
        if (activePerks.includes(perk.id)) {
          perksToDisplay.push(
            <div key={perk.id} className={`perk ${index === 0 ? "keystone" : ""}`}>
              <Rune runeId={perk.id} patch={version} disableTooltip={location.pathname === "/"} ssr={ssr} />
            </div>,
          );
        }
      });
    });

    return perksToDisplay;
  };

  const runeJSON = getRuneJSON(props.perkStyle, { patch: props.version, language, optionalData: data });

  if (!runeJSON) {
    return <div />;
  }

  const classNames = `rune-tree-condensed ${props.pathLabel === false ? "no-path-label" : ""}`;
  return (
    <div className={classNames}>
      <div className="rune-path">
        <Rune runeId={perkStyle} patch={version} disableTooltip={false} ssr={ssr} />
        {props.pathLabel === false ? null : <div>{runeJSON.name}</div>}
      </div>
      <div className="runes-row">{buildPerks(props.version)}</div>
    </div>
  );
};

export default RuneTreeCondensed;
